<div class="form-data-card">
  <div class="card-header">
    <div class="card-title">
      <i class="fas fa-file-text"></i>
      <span>{{ formTitle }}</span>
      <span *ngIf="required" class="required-badge">必要</span>
    </div>
    <div class="card-status">
      <span [class]="'status-badge ' + statusClass">
        {{ statusText }}
      </span>
    </div>
  </div>
  
  <div class="card-content">
    <div class="card-actions">
      <button 
        type="button" 
        class="btn btn-primary btn-add"
        (click)="onAddData()"
        [disabled]="isMaxRecordsReached">
        <i class="fas fa-plus"></i>
        {{ recordCount === 0 ? '填寫' : '新增' }}
      </button>
      
      <button 
        *ngIf="recordCount > 0"
        type="button" 
        class="btn btn-outline-secondary btn-view"
        (click)="onViewList()">
        <i class="fas fa-list"></i>
        查看列表
      </button>
    </div>
    
    <!-- 達到最大筆數限制時的提示 -->
    <div *ngIf="isMaxRecordsReached" class="limit-message">
      <i class="fas fa-info-circle"></i>
      已達到最大填寫筆數限制
    </div>
    
    <!-- 必填未填寫時的提示 -->
    <div *ngIf="required && recordCount === 0" class="required-message">
      <i class="fas fa-exclamation-triangle"></i>
      此項目為必填，請盡快填寫
    </div>
  </div>
</div>

<!-- 表單填寫彈出視窗 -->
<div class="modal-backdrop" *ngIf="showFormModal" (click)="closeFormModal()"></div>
<div class="modal" [class.show]="showFormModal" *ngIf="showFormModal">
  <div class="modal-dialog modal-lg" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-edit me-2"></i>
          {{ recordCount === 0 ? '填寫' : '新增' }}{{ formTitle }}
        </h5>
        <button type="button" class="btn-close" (click)="closeFormModal()" aria-label="關閉">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle"></i>
          {{ errorMessage }}
        </div>
        <div *ngIf="isLoading" class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          載入中...
        </div>
        <app-dynamic-form 
          [formName]="formName"
          [formid]="formid"
          (recordAdded)="onFormSubmitSuccess()">
        </app-dynamic-form>
      </div>
    </div>
  </div>
</div>

<!-- 列表顯示彈出視窗 -->
<div class="modal-backdrop" *ngIf="showListModal" (click)="closeListModal()"></div>
<div class="modal" [class.show]="showListModal" *ngIf="showListModal">
  <div class="modal-dialog modal-xl" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-list me-2"></i>
          {{ formTitle }} - 資料列表 ({{ recordCount }} 筆)
        </h5>
        <button type="button" class="btn-close" (click)="closeListModal()" aria-label="關閉">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="isLoading" class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          載入中...
        </div>
        <app-showlist 
          [formName]="formName"
          [formId]="formid"
          (dataUpdated)="onListDataChanged()">
        </app-showlist>
      </div>
    </div>
  </div>
</div>